import { Injectable, Injector } from '@angular/core';

import { ReportAccountProfileService } from './reportAccountProfile.service';
import { ReportCustomerSummaryService } from './reportCustomerSummary.service';
import { ReportPassengerDetailService } from './reportPassengerDetail.service';
import { ReportTicketSummaryService } from './reportTicketSummary.service';
import { ReportCampaignSummaryService } from './reportCampaignSummary.service';
import { ReportTripSummaryService } from './reportTripSummary.service';
import { ReportServiceAreasService } from './reportServiceAreas.service';
import { ReportShuttlesService } from './reportShuttles.service';
import { ReportDashboardSummaryService } from './reportDashboardSummary.service';
import { ReportTicketDetailService } from './reportTicketDetail.service';
import { ReportSmsDetailService } from './reportSmsDetail.service';
import { ReportDealershipService } from './reportDealership.service';
import { ReportUsersService } from './reportUsers.service';
import { ReportFormatterService } from './reportFormatter.service';
import type { TReportOptions, IReport } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class ReportFactoryService implements IReport {
    constructor(private reportFormatterService: ReportFormatterService, private injector: Injector) {
    }

    //
    public createReportService(reportOptions?: TReportOptions): any {
        let service;
        const reportName = reportOptions.selectedReport.name;

        switch (reportName) {
            // Summary reports section
            case 'campaignSummary':
                service = new ReportCampaignSummaryService(this.injector);
                break;

            case 'customerSummary':
                service = new ReportCustomerSummaryService(this.injector);
                break;

            case 'tripSummary':
                service = new ReportTripSummaryService(this.injector);
                break;

            case 'ticketSummary':
                service = new ReportTicketSummaryService(this.injector);
                break;

            case 'dashboardSummary':
                service = new ReportDashboardSummaryService(this.injector);
                break;

            // Detail reports section
            case 'ticketDetail':
                service = new ReportTicketDetailService(this.injector);
                break;

            case 'passengerDetail':
                service = new ReportPassengerDetailService(this.injector);
                break;

            case 'smsDetail':
                service = new ReportSmsDetailService(this.injector);
                break;

            // Setup reports section
            case 'accountProfile':
                service = new ReportAccountProfileService(this.injector);
                break;

            case 'dealership':
                service = new ReportDealershipService(this.injector);
                break;

            case 'shuttles':
                service = new ReportShuttlesService(this.injector);
                break;

            case 'users':
                service = new ReportUsersService(this.injector);
                break;

            case 'serviceAreas':
                service = new ReportServiceAreasService(this.injector);
                break;

            default:
                service = undefined;
        }

        if (!service) {
            throw new Error('Report Service not defined for: ' + reportName);
        }

        service.initialize(reportOptions);
        return service;
    }

    // We could let reportsPage3 new up the ReportFormatter but I am already using this factory!
    public createReportFormatter(): any {
        return this.reportFormatterService;
    }
}
